import React, { useEffect } from "react";
import { PermissionWrapper } from "components";
import { useAdminStore } from "./stores/adminStore";

import RegistrationForm from "./components/RegistrationForm";
import UsersTable from "./components/UsersTable";
import RolesManagement from "./components/RolesManagement";
import GetTokenButton from "./components/GetTokenButton";

// Головний компонент сторінки "Панель адміністратора"
const AdminPanelPage = () => {
  // Отримуємо необхідні дані та дії зі стору
  const { users, removeUser, init } = useAdminStore();

  useEffect(() => {
    init();
  }, [init]);

  return (
    <section id="admin-panel">
      <div className="page-container">
        <div className="admin-panel-title">
          <div className="admin-panel-title-line">
            <h3>Профіль адміністратора</h3>
            <GetTokenButton />
          </div>
          <PermissionWrapper requiredPermission="users:manage">
            <div className="admin-panel-title-line">
              <RegistrationForm />
            </div>
          </PermissionWrapper>
        </div>

        <div className="admin-panel-container">
          <div className="admin-panel-container-row">
            <UsersTable users={users} onRemove={removeUser} />
          </div>
          <PermissionWrapper requiredPermission="roles:manage">
            <div className="admin-panel-container-row">
              <RolesManagement />
            </div>
          </PermissionWrapper>
        </div>
      </div>
    </section>
  );
};

export default AdminPanelPage;
